<template>
    <div class="input-container activeBtn" :class="{ disabled: disabled }" @click="toggleActive">
        <img class="icon activeBtn" :src="icon" alt="dropdown" />
        <div class="tagsWrapper activeBtn" v-if="selectedItems.length > 0">
            <div
                v-for="selectField in inputDisplay(selectedItems, listTotal || list)"
                class="selectTag activeBtn"
                :key="selectField"
            >
                <span class="activeBtn">
                    {{ selectField }}
                </span>
            </div>
        </div>
        <span class="label activeBtn" :class="(active || selectedItems) && 'label-active'">{{ label }}</span>
        <div v-if="active && !disabled" class="drop-container" :class="{'withSearch' : withSearch, 'drop-container-bigger': dropDownBigger}">
            <div v-if="withSearch" class="multiSelectSearch-container">
                <TextInput :label="$t('title.search')" v-model="searchModel" v-on:change="searchModel.set" />
            </div>
            <div
                v-if="list.length > 0"
                class="item-display"
                :class="this.selectedClass('all')"
                @click="this.toggleSelectAll"
            >
                <span>
                    <CheckBox
                        :label="list.length === listTotal?.length ? $t('all') : $t('allDisplayed')"
                        :checked="isAllSelected"
                    />
                </span>
            </div>
            <div v-if="list.length === 0" class="item-display notFound">
                {{ $t('search.notFound') }}
            </div>
            <div
                v-for="(item, index) in list"
                class="item-display"
                :class="this.selectedClass(item)"
                @click="() => this.toggleCheck(item)"
                :key="index"
            >
                <span>
                    <CheckBox :label="checkboxDisplay(item)" :checked="isChecked(item)" />
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CheckBox from './CheckBox.vue';
import TextInput from './TextInput.vue';

export default defineComponent({
    name: 'DropDownMultiple',
    components: { CheckBox, TextInput },
    data() {
        return {
            active: false,
        };
    },
    props: {
        list: { type: Array, required: true },
        listTotal: { type: Array, required: false },
        selectedItems: { type: Array, required: true },
        inputDisplay: { type: Function, required: true },
        checkboxDisplay: { type: Function, required: true },
        isChecked: { type: Function, required: true },
        label: { type: String, required: true },
        withSearch: { type: Boolean, required: false },
        search: { type: String, required: false },
        dropDownBigger: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false, default: false },
    },
    methods: {
        close(e: MouseEvent) {
            if (!this.$el.contains(e.target)) {
                this.active = false;
            }
        },
        toggleCheck(value: any) {
            if (typeof value === 'object') {
                const find = !!this.$props.selectedItems.find((x: any) => value.id === x.id);
                find ? this.$emit('remove', value) : this.$emit('add', value);
            } else {
                this.$props.selectedItems.includes(value) ? this.$emit('remove', value) : this.$emit('add', value);
            }
        },
        toggleActive(e: MouseEvent) {
            if (this.disabled) {
                return;
            }
            const target = e.target as HTMLTextAreaElement;

            if (target.classList.contains('activeBtn')) {
                this.active = !this.active;
            }
        },
        toggleSelectAll() {
            this.$emit('toggleSelectAll');
        },
        selectedClass(item: any) {
            if (item === 'all') {
                if (typeof this.$props.list[0] === 'string') {
                    const selectedListBool = this.$props.list.map(
                        (x: any) => !!this.$props.selectedItems.find((y: any) => y === x)
                    );

                    return selectedListBool.includes(false) ? '' : 'selected';
                }

                const selectedListBool = this.$props.list.map(
                    (x: any) => !!this.$props.selectedItems.find((y: any) => y.id === x.id)
                );

                return selectedListBool.includes(false) ? '' : 'selected';
            }
            return this.$props.isChecked(item) ? 'selected' : '';
        },
    },
    computed: {
        icon() {
            return require('@/assets/img/menu-down.svg');
        },
        searchModel: {
            get(): string {
                return this?.search ?? '';
            },
            set(search: string) {
                this.$emit('multipleSelectSearch', search);
            },
        },
        isAllSelected(): boolean {
            if (typeof this.$props.list[0] === 'string') {
                return !this.$props.list
                    .map((x: any) => !!this.$props.selectedItems.find((y: any) => y === x))
                    .includes(false);
            }

            return !this.$props.list
                .map((x: any) => !!this.$props.selectedItems.find((y: any) => y.id === x.id))
                .includes(false);
        },
    },
    mounted() {
        document.addEventListener('click', this.close);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.close);
    },
});
</script>

<style scoped>
.input-container {
    box-sizing: border-box;
    height: 50px;
    width: 250px;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 0 12px;
    align-items: center;
    font-weight: 400;
    font-size: var(--font-size-low-medium);
    cursor: pointer;
}

.input-container.disabled {
    cursor: not-allowed;
    background: #F5F5F5;
}

.input-container.disabled .label {
    background: #F5F5F5;
}

.tagsWrapper {
    left: 0;
    display: flex;
    position: absolute;
    overflow: hidden;
    padding: 0 4px;
    width: calc(100% - 32px);
    height: 34px;
}

.text-input {
    border: none;
    outline: none;
    flex: 1;
    color: var(--black);
}
.label {
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: calc(50% - var(--font-size-low-medium) / 2);
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    font-size: var(--font-size-low-medium);
}
.label-active {
    top: -7px;
    font-size: var(--font-size-very-small);
}
.item-display {
    padding: 14px 24px;
    cursor: pointer;
}
.item-display.selected {
    background: rgba(25, 118, 210, 0.12);
}
.notFound {
    text-align: center;
}
.drop-container-bigger {
    max-height: 500px !important;
    width: 200% !important;
}
.drop-container {
    max-height: 250px;
    overflow-y: auto;
    z-index: 10;
    width: 100%;
    background-color: var(--white);
    position: absolute;
    top: 49px;
    left: 0;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.icon {
    margin: 0;
    height: 24px;
}
.selectTag {
    background: var(--medium-light-grey);
    height: 20px;
    line-height: 20px;
    font-size: var(--font-size-small);
    padding: 5px 12px;
    border-radius: 16px;
    margin-top: 4px;
    margin-right: 3px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 30%;
}
.multiSelectSearch-container {
    position: sticky;
    top: 0;
    box-sizing: border-box;
    padding: 8px 16px;
    background: white;
    z-index: 3;
}
.multiSelectSearch-container,
.multiSelectSearch-container * {
    cursor: default;
}
</style>
